var moment = require('moment');

const actCartera = async (descrEmpresa, graphqlFns) => {
  const { allCotizacionRtes, editEmpresa } = graphqlFns;

  try {
    let facturas = []
    let argsQuery = `{$match: {'descrEmpresa': '${descrEmpresa}', 'tipoCoti': 'Cliente'}},
      {"$unwind": "$itemsFactura"},
      {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
        valorFact: '$itemsFactura.valorFact', 
        valorPagado: {
          $let: {
              vars: {valorPago: '$itemsFactura.valorPagado'},
              in: { $cond: { if: { $eq: [ "$$valorPago", null ] }, then: 0, else: "$$valorPago" } }
          }
        },
        numAvance: {"$toString": "$itemsFactura.numAvance"}, numFactura: '$itemsFactura.numFactura', 
        venceFact: '$itemsFactura.venceFact'
      }}, 
      {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, numOrdenCompra: 1, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
        valorFact: 1, valorPagado: 1, numAvance: 1, numFactura: 1, venceFact: 1, 
        totalOC: {
          $let: {
              vars: {valorFact: {$toInt: '$valorFact'}, valorPagado: {$toInt: '$valorPagado'}},
              in: { $subtract: [ "$$valorFact", "$$valorPagado" ] }
          }
        }
      }},
      {$match: {numFactura: {$ne: ""}, totalOC: {$gt: 0}}}, 
      {$sort: {numFactura: 1}}
    ])`

    let argsBuscarFac = {tipoqry: `[${argsQuery}]`}
    let {data} = await allCotizacionRtes.refetch(argsBuscarFac)
    facturas = await data.allCotizacionRtes
    let estadoFact='Sin cartera', factVigentes='', factVencidas=''
    let numVigentes=0, numVencidas=0

    if(facturas.length>0){      
      estadoFact='Cartera vigente' 

      for(let ii=0; ii<facturas.length; ii++){
        if(facturas[ii].venceFact){
          let fechaHoy = new Date()
          fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
          fechaHoy=moment(fechaHoy)
          var fecFin=moment(facturas[ii].venceFact).format('YYYY-MM-DD')
          let numDias= fechaHoy.diff(fecFin, 'days') 
          if(numDias>0){
            if(numVencidas === 0){
              factVencidas=facturas[ii].numFactura
            }else{
              factVencidas+=` - ${facturas[ii].numFactura}`
            }
            numVencidas+=1
            estadoFact='Cartera vencida'
          }else{
            if(numVigentes === 0){
              factVigentes=facturas[ii].numFactura
            }else{
              factVigentes+=` - ${facturas[ii].numFactura}`
            }
            numVigentes+=1
          }
        }
      }
    }

    // await models.Cliente.updateOne({'descrEmpresa': descrEmpresa}, 
    //   {$set:{'estadoFact': estadoFact, 'factVigentes': factVigentes, 'factVencidas': factVencidas}}
    // )
    const argsUpdEmp = {
      tipoAct: 'EditarEstadoFact',
      descrEmpresa: descrEmpresa,
      estadoFact: estadoFact,
      factVigentes: factVigentes,
      factVencidas: factVencidas
    }
    await editEmpresa({variables: argsUpdEmp });
    

  } catch (error) {
    console.error('Error en actcartera:', error);
  }
};
export default actCartera
